import {Component} from 'nuxt-property-decorator';
import PageFromBackendComponent from "../components/base/PageFromBackendComponent";

@Component
export default class Pomoc extends PageFromBackendComponent {
  async asyncData() {
    return PageFromBackendComponent.AsyncData('/komunikat')
  }
}
